import { SHOW_MAIN_ERROR } from "../actions/types";

const initialState = 
	{
		mainErrorPopMsg: false,
		popupAlign: false,
		callokf: null
	};
 
const libraryPopups = (state = initialState, action) => {
  switch (action.type) {
	case SHOW_MAIN_ERROR: {
		return {
			...state,
			mainErrorPopMsg: action.payload.msg,
			popupAlign: action.payload.align,
			callokf: action.payload.callokf
		}
	}
    default: {
      return state;
    }
  }
};

export default libraryPopups;
